import React from 'react'
import AnimatedGradientBackground from './animatedGradientBg'
import Sidebar from './sidebar'

interface GradientContainerProps {
  components?: React.ReactNode[];
}

const GradientContainer = ({ components = [] }: GradientContainerProps) => {
  const getComponentWidth = () => {
    if (components.length === 0) return '';
    if (components.length === 1) return 'w-full';
    if (components.length === 2) return 'w-full md:w-1/2';
    return 'flex-1';
  };

  const componentWidth = getComponentWidth();

  return (
    <div className='relative h-full w-full rounded-2xl overflow-hidden'>
      <AnimatedGradientBackground />
      <Sidebar />
      
      {/* Components positioned to the right of the sidebar on desktop, full width on mobile */}
      <div className='absolute inset-0 md:ml-[33%] flex flex-col md:flex-row h-full'>
        {components.map((component, index) => (
          <div 
            key={index}
            className={`${componentWidth} h-full ${
              index > 0 ? 'border-t md:border-t-0 md:border-l border-white/20' : ''
            }`}
          >
            {component}
          </div>
        ))}
      </div>
    </div>
  )
}

export default GradientContainer